import { useState } from "react";
import { Loader2, Smartphone, Send } from "lucide-react";
import { toast } from "sonner";
import { QRCodeCanvas } from "qrcode.react";
import api, { formatApiError } from "@/lib/api";

export function MonterAppCard({ t, canSend, embedded }) {
  const [busy, setBusy] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const url = (typeof window !== "undefined" ? window.location.origin : "") + "/m";
  const inp = "w-full bg-slate-900 border border-slate-700 rounded px-2 py-2 text-sm outline-none focus:ring-1 focus:ring-cyan-500";
  const send = async () => {
    if (!body.trim()) { toast.error(t("Podaj treść powiadomienia")); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/push/send", { title: title.trim() || "FiberPass", body: body.trim() });
      if (data.recipients === 0) toast.info(t("Brak monterów w systemie."));
      else if (data.sent === 0) {
        const reason = (data.errors && data.errors[0]) ? ` — ${data.errors[0]}` : "";
        toast.warning(`${t("Wysłano:")} 0/${data.recipients}.${reason}`, { duration: 12000 });
      }
      else toast.success(`${t("Wysłano do monterów:")} ${data.sent}/${data.recipients}`);
      setBody(""); setTitle("");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className={embedded ? "" : "bg-slate-800 border border-slate-700 rounded-lg p-4"} data-testid="settings-monter-app">
      {!embedded && <h3 className="font-heading font-bold text-sm mb-3 flex items-center gap-2"><Smartphone size={16} className="text-cyan-400" /> {t("Aplikacja montera (na telefon)")}</h3>}
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <div className="bg-white p-2 rounded-lg shrink-0"><QRCodeCanvas value={url} size={140} data-testid="monter-app-qr" /></div>
        <div className="flex-1 text-sm text-slate-300 space-y-2">
          <p>{t("Zeskanuj telefonem, aby otworzyć aplikację montera. Na telefonie wybierz „Dodaj do ekranu głównego”, aby zainstalować i otrzymywać powiadomienia push.")}</p>
          <a href={url} target="_blank" rel="noreferrer" className="text-cyan-400 break-all underline" data-testid="monter-app-link">{url}</a>
        </div>
      </div>
      {canSend && (
        <div className="mt-4 border-t border-slate-700 pt-3 space-y-2">
          <div className="text-xs font-semibold text-slate-400">{t("Wyślij powiadomienie push do monterów")}</div>
          <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder={t("Tytuł")} className={inp} data-testid="push-send-title" />
          <textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder={t("Treść powiadomienia")} rows={2} className={inp} data-testid="push-send-body" />
          <button onClick={send} disabled={busy} data-testid="push-send-btn"
            className="w-full bg-cyan-600 hover:bg-cyan-500 disabled:opacity-60 rounded py-2 text-sm font-medium flex items-center justify-center gap-2">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} {t("Wyślij do wszystkich monterów")}
          </button>
        </div>
      )}
    </div>
  );
}
